import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fires a lightweight ``/api/health`` ping when the caller mounts,
 * then again every ``intervalMs`` while the caller stays mounted.
 *
 * We use it on the login screen so the backend container has already
 * warmed up by the time the user finishes typing their PIN — no more
 * "first login of the shift is 18 seconds" complaints.
 *
 * The ping is best-effort: we swallow every error so a flaky WiFi
 * never breaks the login UX. Interval is set well below every known
 * managed-hosting idle-sleep window (Emergent, Vercel, Fly, Railway,
 * etc. all sit in 5–30 min territory).
 */
const useBackendKeepAlive = ({ intervalMs = 4 * 60 * 1000 } = {}) => {
  useEffect(() => {
    let cancelled = false;
    const ping = () => {
      // ``timeout`` is intentionally generous so a first-load cold
      // start doesn't get aborted — we WANT that request to wake the
      // container, even if it takes 20s.
      axios.get(`${API}/health`, { timeout: 30000 }).catch(() => {});
    };
    ping();
    const id = setInterval(() => { if (!cancelled) ping(); }, intervalMs);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [intervalMs]);
};

export default useBackendKeepAlive;
